export enum LeadType {
  contract = 'contract',
  advice = 'advice',
}

export enum LeadReceiver {
  nortempo = 'Nortempo',
  gelpy = 'Gelpy',
}

export interface Lead {
  name: string
  email: string
  phone: string
  requestId: string
  type: LeadType
}

export interface LeadDto {
  name: string
  email: string
  phone: string
  requestId: string
  receiver: LeadReceiver
}



// WEBPACK FOOTER //
// ./src/domain/model/lead/newLead.model.ts